import CircleIcon from '@mui/icons-material/Circle'
import { Link, MenuItem, Stack, Typography } from '@mui/material'

import { Notification as NotificationProps } from './types'

import { formatDateAndTime } from '@/util/date'

import { Row } from '@/Components/Layout/Row'

const Notification: React.FC<NotificationProps> = ({
  id,
  message,
  userName,
  createdAt
}) => {
  return (
    <MenuItem
      component={Link}
      href={`/user_notifications/${id}`}
      sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
      }}
    >
      <Row gap={1} sx={{ width: '100%', alignItems: 'flex-start' }}>
        <CircleIcon color="primary" sx={{ fontSize: 14, mt: 1 }} />
        <Stack gap={0.25} sx={{ width: '100%' }}>
          <Typography>{message}</Typography>
          <Row gap={0.5} alignItems="center" flexWrap="wrap">
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ whiteSpace: 'normal' }}
            >
              {userName}
            </Typography>
            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ whiteSpace: 'normal' }}
            >
              {formatDateAndTime(new Date(createdAt))}
            </Typography>
          </Row>
        </Stack>
      </Row>
    </MenuItem>
  )
}

export default Notification
